/**
 * 描述：省市县三级联动
 * 日期：2017-7-13
 * 作者：Bai Zhiming
 */
"use strict";
angular.module("provinceAndCitiesModule", [])
    .directive("provinceAndCities", ["$timeout", "$q", "httpService", function($timeout, $q, httpService) {

        return {
            restrict: "E",
            replace: true,
            scope: {
                callback: "&",
                province: "=",
                city: "=",
                district: "="
            },
            templateUrl: "./utils/provincesAndCities/provinceAndCities_tpl.html",
            link: function(scope, elem, attrs) {
                initStatus();
                initData();
                scope.$watch("province", function(newV, oldV) {
                    initStatus();
                    initData();
                });
                scope.$watch("city", function(newV, oldV) {
                    initStatus();
                    initData();
                });
                scope.$watch("district", function(newV, oldV) {
                    initStatus();
                    initData();
                });

                function initStatus() {
                    scope.status = {
                        provinceCopy: angular.copy(scope.province),
                        cityCopy: angular.copy(scope.city),
                        districtCopy: angular.copy(scope.district)
                    };
                    scope.data = {};
                }

                function initData() {
                    getProvincesList().then(function() {
                        if (scope.province) {
                            for (var i = 0; i < scope.status.provincesList.length; i++) {
                                if (scope.status.provincesList[i].name === scope.status.provinceCopy) {
                                    scope.status.selectedProvince = scope.status.provincesList[i];
                                    scope.province = scope.status.selectedProvince.name;
                                    break;
                                }
                            }
                            getCitiesList();
                            for (var j = 0; j < scope.status.citiesList.length; j++) {
                                if (scope.status.citiesList[j].name === scope.status.cityCopy) {
                                    scope.status.selectedCity = scope.status.selectedProvince.city[j];
                                    scope.city = scope.status.selectedCity.name;
                                    break;
                                }
                            }
                            getDistrict();
                            for (var k = 0; k < scope.status.districtList.length; k++) {
                                if (scope.status.districtList[k].name === scope.status.districtCopy) {
                                    scope.status.selectDistrict = scope.status.districtList[k];
                                    scope.district = scope.status.selectDistrict.name;
                                    break;
                                }
                            }
                        } else {
                            getCitiesList();
                            getDistrict();
                            //scope.callback();
                        }
                    });
                }

                function getProvincesData() {

                }

                function getProvincesList() {
                    var deffer = $q.defer();
                    httpService.http("./utils/provincesAndCities/province_data.json", "", "get")
                        .then(function(data) {
                            scope.status.provincesList = data;
                            scope.status.selectedProvince = angular.copy(scope.status.provincesList[10]);
                            scope.province = scope.status.selectedProvince.name;
                            scope.optionp = scope.province;
                            deffer.resolve();
                        });
                    return deffer.promise;
                }

                function getCitiesList() {
                    scope.status.citiesList = angular.copy(scope.status.selectedProvince.city);
                    scope.status.selectedCity = angular.copy(scope.status.selectedProvince.city[0]);
                    scope.city = scope.status.selectedCity.name;
                    scope.optionc = scope.city;
                }

                function getDistrict() {
                    scope.status.districtList = (function() {
                        var array = [];
                        var area;
                        for (var i = 0; i < scope.status.selectedCity.area.length; i++) {
                            area = scope.status.selectedCity.area[i];
                            array.push({ name: area });
                        }
                        return array;
                    })();
                    scope.status.selectDistrict = angular.copy(scope.status.districtList[3]);
                    scope.district = scope.status.selectDistrict.name;
                    scope.optiond = scope.district
                }

                scope.selectProvince = function() {
                    scope.province = scope.status.selectedProvince.name;
                    getCitiesList();
                    getDistrict();
                    scope.callback();
                };
                scope.selectCity = function() {
                    getDistrict();
                    scope.callback();
                    scope.city = scope.status.selectedCity.name;
                };
                scope.selectDistrict = function() {
                    scope.callback();
                    scope.district = scope.status.selectDistrict.name;
                };
            }
        };
    }]);